import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';

export default function CnaeTitle({ cnae, status }) {
  const [colorStatus, setColorStatus] = useState('');
  const { concomitante, impedido } = status;

  useEffect(() => {
    if (impedido) {
      setColorStatus('#DE350B');
    } else {
      setColorStatus('#31AEFF');
    }

    if (concomitante) setColorStatus('#FF9505');
  }, [status]);

  const useStyles = makeStyles((theme) => ({
    title: {
      color: '#A39EB8',

    },
    cnae: {
      color: colorStatus,
      fontWeight: '700',
    }
  }))

  const classes = useStyles();

  return (
    <Typography variant={'subtitle2'} component={'span'} className={classes.title}>
        CNAE: <span className={classes.cnae}>{cnae}</span>
    </Typography>
  )
}

CnaeTitle.propTypes = {
  cnae: PropTypes.string.isRequired,
  status: PropTypes.objectOf(PropTypes.string).isRequired
}
CnaeTitle.defaultProps = {
  cnae: '0000-0/00',
  status: 'Permitido'
}
